import React from 'react';
import Container from '@/components/container';
import ContextProviderMenus from '@/components/slide-menu/provide-slide-menu';
import TabNav from '@/components/slide-menu/tab-nav';
import { Badge } from 'antd';
import { routeItemIsCheck } from './route-config';
import { useApiGetTotalAuditNumber } from '@/apis/activityPlan/getTotalAuditNumber';
import './index.less';

function RoomActivity(props: { children: React.ReactNode }) {
  const [data] = useApiGetTotalAuditNumber();

  return (
    <div style={{ backgroundColor: 'white' }}>
      <ContextProviderMenus.Provider value={{ children: props.children }}>
        <Container
          paddingSize="max"
          style={{ marginTop: 20 }}
          margin={{ top: true }}
          marginSize="max"
          padding={{ horizontal: true }}
        >
          <TabNav
            renderTabNavItem={({ title, path }) => {
              if (data.loading) return title;
              if (!routeItemIsCheck({ title, path })) return title;
              if (data)
                return (
                  <>
                    {title}
                    <Badge size="small" className="badge-in-check" count={data.count}></Badge>
                  </>
                );
            }}
            linkEndWithSearch={false}
          />
        </Container>
        {props.children}
      </ContextProviderMenus.Provider>
    </div>
  );
}

export default RoomActivity;
